import GlobalStateContext from "contexts/GlobalStateContext";
import { useContext } from "react";

export default function useUpdateWorkOrderDatesModal() {
  const { state, setState: updateGlobalState } = useContext(GlobalStateContext);

  const setState = (args) => {
    const newState = { ...state.updateWorkOrderDatesModalState, ...args };
    updateGlobalState({ updateWorkOrderDatesModalState: newState });
  };

  return {
    close: () => setState({ isOpen: false }),
    isOpen: state.updateWorkOrderDatesModalState.isOpen,
    open: () => setState({ isOpen: true }),
  };
}
